// API
import { api } from './api';

export default async function postWorkflowCancelTask(leadId: string, data: any, token: string): Promise<any> {
    let _url = api.workflowCancel.replace(/:leadId/, leadId);

    const resp = await fetch(_url, {
        method: 'POST',
        headers: {
            'Accept-Language': 'de-DE',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(data),
    });

    if (resp.status === 200) {
        return Promise.resolve(true);
    } else {
        Promise.reject();
    }
}
